<script setup lang="ts">
import SwimlaneIcon from '@apparatix/icons/SwimlaneIcon.vue';
import GridIcon from '@apparatix/icons/GridIcon.vue';

interface LeadFilterButtonProps {
  name: 'grid' | 'swimlane';
  selected: boolean;
}

defineProps<LeadFilterButtonProps>();
</script>
<template>
  <button type="button" :style="{background: selected ? '#E3E1FF' : ''}">
    <SwimlaneIcon v-if="name === 'swimlane'" :color="selected ? '#4F46E5' : '#788EAE'" />
    <GridIcon v-if="name === 'grid'" :color="selected ? '#4F46E5' : '#788EAE'" />
  </button>
</template>
<style scoped>
button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border: none;
  background: none;
  border-radius: 8px;
}
</style>
